import { types as t, Instance } from '@invisr/mobx-state-tree'
import crudActions from './crud-actions'
import Mapping, { IMapping } from './mapping'
import type { WithDS } from "./datasource-type";

export class WorkflowProvider {
  config

  constructor(config) {
    this.config = config
  }

  run = async (inputs) => {
    try {
      const result = await fetch(`/api/datasource/${this.config.dbKey}/run`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ params: inputs })
      })
      const { workflowId } = await result.json()
      return workflowId
    } catch (e) {
      console.error('Run workflow failed with error: ', e);
    }
  }

  query = async (workflowId: string | string[]) => {
    try {
      const result = await fetch(`/api/datasource/${this.config.dbKey}/query`, {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ workflowId })
      })
      return await result.json()
    } catch (e) {
      console.error('Query method of workflow failed with error: ', e);
    }
  }

  signal = async (workflowId: string, signal: string, payload: any) => {
    try {
      await fetch(`/api/datasource/${this.config.dbKey}/signal`, {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ workflowId, payload, signal })
      })
    } catch (e) {
      console.error('Signal method of workflow failed with error: ', e);
    }
  }

  restart = async (workflowId: string | string[]) => {
    try {
      const request = { workflowId: workflowId, datasourcekey: this.config.dbKey }
      const result = await fetch(`/api/workflow/restart`,
        {
          method: 'POST',
          body: JSON.stringify(request),
          headers: { 'Content-Type': 'application/json' }
        });
      return await result.json()
    } catch (e) {
      console.error('Restart method of workflow failed with error: ', e);
    }
  }
}
/*
const Workflow = t
  .model('Workflow', {
    type: t.optional(t.string, 'Workflow'),
    steps: t.array(Step),
    inputs: t.maybeNull(t.late(() => Mapping)),
    validationError: t.maybeNull(t.string)
  })
  .actions(crudActions)
  .actions(self => ({
    afterCreate() {
      // if (!self.spec) {
      //   self.update({ spec: {} })
      // }
      if (!self.inputs) {
        self.update('inputs', {
          type: 'object',
          children: []
        })
      }
      self.validationError = 'Invalid state exists'
    },
    // afterSave(before, after) {
    //   for (const state of after.spec.states) {
    //     if (state.type === 'switch') {
    //       for (const condition of state.dataConditions) {
    //         if (condition.metadata.isElseStatement && !condition.transition) {
    //           state.removeCondition(condition.condition)
    //         }
    //       }
    //     }
    //   }
    // },
    setValidationError(validationError) {
      self.validationError = validationError
    }
  }))
  .views(self => ({
    get provider() {
      return WorkflowProvider
    },
    get mapping() {
      return self.inputs;
    },
    // get isValid(): boolean {
    //   return self.spec.isWorkflowStatesValid
    // },
    labels() {
      return {
        key: (self as any).id as string,
        label: (self as any).name as string,
        childNodes: [
          {
            key: 'methods',
            label: 'Methods',
            childNodes: [
              {
                key: 'run',
                label: 'run',
                secondaryLabel: 'FUNCTION'
              },
              {
                key: 'query',
                label: 'query',
                secondaryLabel: 'FUNCTION'
              },
              {
                key: 'signal',
                label: 'signal',
                secondaryLabel: 'FUNCTION'
              },
              {
                key: 'restart',
                label: 'restart',
                secondaryLabel: 'FUNCTION'
              }
            ]
          }
        ]
      }
    }
  }))
  .actions(self => ({
    async fetchExecutions(nextPageToken: any) {
      let result = {};
      try {
        let url: string = `/api/workflow/allWorkflows?dataSourceKey=${(self as any).key}`;
        if (nextPageToken) url += `&nextPageToken=${nextPageToken}`;
        result = await fetch(url).then(r => r.json());
      } catch (e) {
        console.error('Fetch executions of workflow failed with error: ', e);
      }
      return result;
    }
  }))
*/
export interface IWorkflowDataSource extends WithDS<Instance<typeof Workflow>> { }
